module.exports = __webpack_public_path__ + "static/media/asset_on.586703a7.png";